import { render, staticRenderFns } from "./MainBoard.vue?vue&type=template&id=2c5f4b1a&scoped=true"
import script from "./MainBoard.vue?vue&type=script&lang=js"
export * from "./MainBoard.vue?vue&type=script&lang=js"
import style0 from "./MainBoard.vue?vue&type=style&index=0&id=2c5f4b1a&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c5f4b1a",
  null
  
)

export default component.exports